import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Profile } from '@tekman/onmat/models';
import { UserService } from '@tekman/onmat/service/generic';
import { ProfileFacade } from '@tekman/onmat/store/profile';
import { SubSink } from '@tekman/shared/utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { appRoutes } from '@tekman/onmat/constants';
import { filter } from 'rxjs/operators';
import Intercom from '@intercom/messenger-js-sdk';
import { BigqueryProxyService } from '@tekman/shared/service';

declare global {
  interface Window {
    hsConversationsSettings: any;
  }
}

@Component({
  selector: 'root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isLandscape = false;
  isMobile = false;
  isTablet = false;
  private subscriptions: SubSink = new SubSink();
  profile: Profile;
  public showHeader = true;

  constructor(
    public readonly profileFacade: ProfileFacade,
    private readonly _deviceService: DeviceDetectorService,
    private userService: UserService,
    private readonly _router: Router,
    private bigqueryProxyService: BigqueryProxyService
  ) {
    this.isMobile = this._deviceService.isMobile();
    this.isTablet = this._deviceService.isTablet();
    this.isLandscape = window.innerWidth > window.innerHeight;
  }

  ngOnInit(): void {
    this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.showHeader = !event.url.includes(appRoutes.error);
      if (!event.url.includes('/' + appRoutes.itineraries) && event.url !== '/') {
        sessionStorage.setItem('shouldNotRedirect', 'true');
      }
    });
    if (this.userService.isTeacher()) {
      this.setupIntercom();
    }
    this.subscriptions.sink = this.profileFacade.profile$.subscribe(profile => {
      this.profile = profile;
    });
  }

  loadAnyway() {
    this.isMobile = false;
    this.isTablet = false;
  }

  setupIntercom() {
    const user = this.userService.getUser();
    const roles = (user.attributes.roles as string[]).join(',').toUpperCase() || 'TEACHER';
    this.bigqueryProxyService.getIntercomToken(roles, user.attributes.language as string).subscribe({
      next: (result: any) => {
        if (result.data) {
          Intercom({
            app_id: 'n7kkdgak',
            region: 'eu',
            name: user.firstName + ' ' + user.lastName,
            email: user.email,
            session_duration: 86400000,
            intercom_user_jwt: result.data,
          });
        } else {
          console.error('Intercom token not found', result.error);
        }
      },
      error: (result: any) => {
        console.error('Error getting intercom token', result.status, result.error);
      },
    });
  }
}
